import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../../common/models/single-response.model';

import { SummaryTicketModel } from '../../models/summary-ticket.model';
import { LoadTicketsSuccess, TicketActions, TicketActionTypes } from '../actions/ticket.actions';


export interface TicketState {
  items: SummaryTicketModel[];
  total: number;
  res: PaginableResponseModel<SummaryTicketModel> | null;
  selected: SingleResponseModel<SummaryTicketModel> | null;
  loading: boolean;
  error: any
}


export const initalState: TicketState = {
  items: [],
  total: 0,
  res: null,
  selected: null,
  loading: false,
  error: null
};

export function TicketReducer(
  state = initalState,
  action: TicketActions
): TicketState {

  switch (action.type) {
    case TicketActionTypes.LoadTickets:
      return { ...state, loading: true, error: null };

    case TicketActionTypes.LoadTicketsSuccess:
      const { items, total } = (action as LoadTicketsSuccess).payload;
      return {
             ...state,
             loading: false,
             error: null,
             items: items,
             total: total,

           };
    case TicketActionTypes.LoadTicketsFailure:
      return{ ...state, loading: false, error: action.payload.error };


    case TicketActionTypes.LoadTicketSuccess:
      return {
        ...state,
        selected: action.payload
      };

    default:
      return state;
  }
}
